import { DeepLinkModule } from './types';
export const MODULE_ALIASES = {
    billing: DeepLinkModule.COBRANCAS,
    benefits: DeepLinkModule.BENEFICIOS,
    beneficios: DeepLinkModule.BENEFICIOS,
};
